import { Button, Row } from "antd";
import React, { useEffect, useState } from "react";
import { COLORS } from "../../../constants";

const CarouselButtons = (props) => {
  const [width, setWidth] = useState(window.innerWidth);
  const [isMobile, setisMobile] = useState(true);
  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  useEffect(() => {
    if (width <= 768) {
      return setisMobile(true);
    }
    setisMobile(false);
  }, [width]);

  return (
    <div className="carousel-button-container">
      {!isMobile && (
        <Row justify={"space-between"}>
          <Button
            type="primary"
            onClick={() => props.carouselRef.current.prev()}
          >
            PREVIOUS
          </Button>

          <Button
            style={{ backgroundColor: COLORS.orange, border: 0 }}
            type="primary"
            onClick={() => props.carouselRef.current.next()}
          >
            NEXT
          </Button>
        </Row>
      )}
    </div>
  );
};

export default CarouselButtons;
